import React, { useEffect, useState, useContext } from 'react'
import { useLocation, Link } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import { useAuthFetch } from '../utils/api'
import './SearchResults.css'

export default function SearchResults() {
  const { token } = useContext(AuthContext)
  const fetcher = useAuthFetch()
  const { search } = useLocation()
  const q = new URLSearchParams(search).get('q') || ''

  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!q) return
    setLoading(true)
    fetcher(`/api/search?q=${encodeURIComponent(q)}`, token)
      .then(res => {
        if (!res.ok) throw new Error(`Error ${res.status}`)
        return res.json()
      })
      .then(data => {
        setResults(data)
        setLoading(false)
      })
      .catch(err => {
        console.error(err)
        setError(err.message)
        setLoading(false)
      })
  }, [q, fetcher, token])

  if (!q) return <p className="center-message">Type something to search…</p>
  if (loading) return <p className="center-message">Searching…</p>
  if (error) return <p className="center-message error">Error: {error}</p>

  return (
    <div className="search-results-page">
      <h1>Results for “{q}”</h1>
      {results.length > 0 ? (
        results.map((item, idx) => (
          <div key={idx} className="result-item">
            <Link to={item.url} className="result-title">
              {item.title}
            </Link>
            {item.snippet && <p className="result-snippet">{item.snippet}…</p>}
          </div>
        ))
      ) : (
        <p>No results found.</p>
      )}
    </div>
  )
}
